export default {"src":"/_next/static/media/PrincipalNegativa.4e30bfa1.svg","height":531,"width":1291};